// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger'),
        $skyline = $('.header-skyline')
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $skyline.addClass('menu-active');
        $hamburger.addClass('is-active')
    } else {
        $menu.removeClass('menu-active');
        $skyline.removeClass('menu-active');
        $hamburger.removeClass('is-active')
    }
});

//Splide Carousel
$('.splide').each(function() {
    var options = {
        perPage: 3,
        rewind: true,
        pagination: false,
        width: 1565,
        fixedWidth: 475,
        breakpoints: {
            1700: {
                perPage: 2,
                width: 1020
            },
            1150: {
                perPage: 1,
                width: 475
            },
            620: {
                width: 300
            },
            450: {
                width: 250
            }
        }
    }

    if($(this).hasClass('vehicle-main')) {
        options = {
            type: 'loop',
            pagination: false,
            width: 1240,
            height: 650,
            cover: true,
            breakpoints: {
                750: {
                    height: 300,
                }
            }
        }

        let main = new Splide(this, options);

        let thumbnails = document.getElementsByClassName( 'thumbnail' );
        let current;

        for ( let i = 0; i < thumbnails.length; i++ ) {
            initThumbnail( thumbnails[ i ], i );
        }

        // The function to initialize each thumbnail
        function initThumbnail( thumbnail, index ) {
            thumbnail.addEventListener( 'click', function () {
                main.go( index );
            });
        }

        main.on( 'mounted move', function () {
            let thumbnail = thumbnails[ main.index ];

            if ( thumbnail ) {
                if ( current ) {
                    current.classList.remove( 'is-active' );
                }

                thumbnail.classList.add( 'is-active' );
                current = thumbnail;
            }
        });

        main.mount();
    } else {
        let splide = new Splide(this, options);
        splide.mount();
    }
})
